/**
 * Route for `custom-export-schedule-daily-weekly-custom-interva`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomExportScheduleDailyWeeklyCustomIntervaPage } from "../features/custom-export-schedule-daily-weekly-custom-interva/CustomExportScheduleDailyWeeklyCustomIntervaPage";

export const customExportScheduleDailyWeeklyCustomIntervaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-export-schedule-daily-weekly-custom-interva",
	component: CustomExportScheduleDailyWeeklyCustomIntervaPage,
});

export default customExportScheduleDailyWeeklyCustomIntervaRoute;
